import { render, staticRenderFns } from "./replacementItemsView.vue?vue&type=template&id=848110f6&scoped=true&"
import script from "./replacementItemsView.vue?vue&type=script&lang=js&"
export * from "./replacementItemsView.vue?vue&type=script&lang=js&"
import style0 from "./replacementItemsView.vue?vue&type=style&index=0&id=848110f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848110f6",
  null
  
)

export default component.exports